/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Privacy_TitleInputs */

const en_pc_online_privacy_title = /** @type {(inputs: Pc_Online_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your file never leaves your device`)
};

const zh_pc_online_privacy_title = /** @type {(inputs: Pc_Online_Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的文件不会离开你的设备`)
};

/**
* | output |
* | --- |
* | "Your file never leaves your device" |
*
* @param {Pc_Online_Privacy_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_privacy_title = /** @type {((inputs?: Pc_Online_Privacy_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Privacy_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_privacy_title(inputs)
	return zh_pc_online_privacy_title(inputs)
});
export { pc_online_privacy_title as "pc.online.privacy_title" }